export default "__VITE_ASSET__b34801c9__"